var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{staticClass:"p-routed-tabs"},_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab.route,attrs:{"to":{ name: tab.route }}},[_vm._v(" "+_vm._s(tab.title)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }